export const HERO_VIDEO_UPDATE = 'hero-video::update';
export const HERO_VIDEO_PAUSE = 'hero-video::pause';
export const HERO_VIDEO_TOGGLE_PLAYING = 'hero-video::toggle-playing';
export const HERO_VIDEO_BACKGROUND_PLAYING = 'hero-video::background-playing';
